export interface Notification {
  id: number;
  uuid: string;
  type: string;
  title?: string;
  content?: string;
  description?: string;
  read: boolean;
  created: string;
  updated: string;
  branch: string;
  icon: string;
  action: string;
  params: any;
  date: string;
  hasLink: string;
}

export interface Action {
  action: NotificationAction;
  notificationId: number;
}

export enum NotificationAction {
  READ_ALL,
  READ,
  CLEAR,
  CLEAR_MESSAGES,
  READ_ALL_MESSAGE,
}
